module.exports = __webpack_public_path__ + "img/vote-btn_txt_end.c4d76d91.png";